import React, { Component } from "react";
import { authenticateUser } from "../actions/LoginAction";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Axios from "axios";
import * as Constants from "../../constants/Constants";
import { Modal } from "react-bootstrap";
//import "bootstrap/dist/css/bootstrap.css";
import "../../css/components/Login.css"
import { updateUserAgreement,reastAndHandleClose } from "../actions/LoginAction";
import { Document, Page } from 'react-pdf';
import Input from '../components/subcomponents/Form_Components/Input';
import Select from "react-select";
import { Multiselect } from 'multiselect-react-dropdown';
import T from "i18n-react";
import BackDrop from '../components/BackDrop';
// import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "../../authConfig";

@connect((store) => {
    return {
        isAuthenticated: store.loginreducer.isAuthenticated,
        displaySuccessMessage: store.loginreducer.displaySuccessMessage,
        userRegSucess: store.loginreducer.userRegSucess,
        displayErrorMessage: store.loginreducer.displayErrorMessage,
        loading : store.loginreducer.loading,
    };
})

export default class Login extends Component {
    constructor() {
        super();


        this.state = {
            username: '',
            password: '',
            displayLogin: false,
            displayHardware: false,
            emailID: "",
            disableSubmit: true,
            role_selected: "",
            role_selected_hardware: "",
            roles: [],
            selectedRoles: [],
            hardware_sel: "",
            enableTCModal: false,
            useralreadyExists: false,
            loading:false,

            options: [
                { id: 'Package_Release_Manager', name: 'Package Release Manager' },
                { id: 'Fota_Approver', name: 'FOTA Approver' },
                { id: 'Fota_Campaign_Manager', name: 'FOTA Campaign Manager' },
                { id: 'System_Admin_SCC', name: 'System Admin SCC' },
                { id: 'System_Admin_RO', name: 'System Admin RM' },
                { id: 'System_Admin_RM', name: 'System Admin RO' },
                { id: 'L2Operations', name: 'L2Operations' },
                { id: 'RM_Customer_Admin', name: 'RM Customer Admin' },
                { id: 'RM_Customer', name: 'RM Customer' },
                { id: 'RM_ManagementAPI_User', name: 'RM ManagementAPI User' },
                { id: 'Download_Manager', name: 'Download Manager' },
            ],
            emailLoginRedirect: "",
            errors: {},
            validateEmailLoginRedirect: true

        }

        this.handleClose = this.handleClose.bind(this);
        this.enableSubmit = this.enableSubmit.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.emailValidationHandler = this.emailValidationHandler.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.closeMessage = this.closeMessage.bind(this);
        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
        this.enableTC = this.enableTC.bind(this);
        this.closeTerms = this.closeTerms.bind(this);
        this.multiselectRef = React.createRef();
    }

    loginCheck = () => {
        const { username, password } = this.state;
        this.setState({
            invalidUsername: username.trim().length == 0 ? true : false,
            invalidPassword: password.trim().length == 0 ? true : false
        }, this.login)
    }
    onChange = (event) => {
        const element = event.currentTarget;
        const elementId = element.id;
        const elementvalue = element.value;
        if (elementId === 'username') {
            const invalidUsername = elementvalue.trim().length > 0 ? false : true
            this.setState({
                username: elementvalue,
                invalidUsername: invalidUsername
            })
        } else if (elementId === 'password') {
            const invalidPassword = elementvalue.trim().length > 0 ? false : true
            this.setState({
                password: elementvalue,
                invalidPassword: invalidPassword
            })
        }
    }
    login = () => {
        const { username, password } = this.state;
        this.redirectToCiamLogin();
    }

    redirectToCiamLogin = () => {
        //event.preventDefault();

        this.sendGetRequest(Constants.CONFIG.discovery_endpoint, function (request, body) {

            // Save the endpoints for later use
            localStorage.setItem("authorization_endpoint", body.authorization_endpoint);
            localStorage.setItem("token_endpoint", body.token_endpoint);
            localStorage.setItem("end_session_endpoint", body.end_session_endpoint);
            localStorage.setItem("userinfo_endpoint", body.userinfo_endpoint);
            localStorage.setItem("jwks_uri", body.jwks_uri);
            sessionStorage.setItem("platform", Constants.SKID);

            // save the state
            //   localStorage.setItem("ciam_state", Constants.CONFIG.state);

            var params = {
                response_type: "code",
                client_id: encodeURIComponent(Constants.CONFIG.client_id),
                state: encodeURIComponent(Constants.CONFIG.state),
                scope: encodeURIComponent(Constants.CONFIG.requested_scopes),
                redirect_uri: encodeURIComponent(Constants.CONFIG.redirect_uri),
                style_id: encodeURIComponent(Constants.CONFIG.styleId),
                              
            }

            var finalParams = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            // Build the authorization URL
            var url = localStorage.getItem("authorization_endpoint") + "?" + finalParams;
          
            // Redirect to the authorization server
            window.location = url;
        }, function (request, error) {
            // This could be an error response from the OAuth server, or an error because the 
            // request failed such as if the OAuth server doesn't allow CORS requests
            //showToastError(error.error_description);
            console.log(error.error_description);
        });
    }
    sendGetRequest(url, success, error) {
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        request.onload = function () {
            var body = {};
            try {
                body = JSON.parse(request.response);
            } catch (e) { }
            if (request.status == 200) {
                success(request, body);
            } else {
                error(request, body);
            }
        }
        request.onerror = function () {
            error(request, {});
        }
        request.send();
    }
    showRegistration = () => {

        this.setState({
            displayLogin: true,
        })
    }
    toggleSelection = (e) => {

        let value = Array.from(e.target.selectedOptions, option => option.value);
        this.setState({
            role_selected: value,
        });
        if (value.indexOf("package_release_manager") != -1) {

            this.setState({
                displayHardware: true
            })
        } else {
            this.setState({
                displayHardware: false
            })
        }

    }
    handleChange(e) {
        const updatedState = {
            ...this.state
        }
        this.setState({ [e.target.name]: [e.target.value] });
        const email = e.target.value;
        /* if (validator.isEmail(email)) { 
             setEmailError('Valid Email :)') 
           } else { 
             setEmailError('Enter valid Email!') 
           }*/
    }
    handleClose(e) {
        this.setState({
            displayLogin: false,
        });
        this.props.dispatch(reastAndHandleClose());
        this.setState({displaySuccessMessage:false,displayErrorMessage:false}); //This is not working. Need to check
       
        this.resetForm();
    }

    componentDidMount() {
        let email = this.getCookie("email");
        if (email != null) {
            if (email.includes("bosch.com")) {
                this.handleAzureLogin();
            } else {
                this.redirectToCiamLogin();
            }
        }
    }

    handleSubmit(e) {
        
        if (this.emailValidationHandler() && !this.state.useralreadyExists) {
            //formdata.append("role_selected", this.state.role_selected_hardware);
            var selRole = ""
            for (var i = 0; i < this.state.selectedRoles.length; i++) {
                selRole = selRole + this.state.selectedRoles[i].id + ",";
            }
            if (this.state.selectedRoles.length > 0) {
                for (var i = 0; i < this.state.selectedRoles.length; i++) {
                    if (this.state.selectedRoles[i].id.indexOf("Package_Release_Manager") != -1) {
                        if (!this.isEmpty((this.state.hardware_sel))) {
                            selRole = this.state.hardware_sel + ":" + selRole;

                        } else {
                            document.getElementById("opnunit_Label").innerHTML = "Choose operational unit to continue ";
                        }
                    } else {
                        //formdata.append("role_selected", selRole);
                        //this.props.dispatch(updateUserAgreement(formdata));

                    }
                }
                var formdata = new FormData();
                formdata.append("email_id", this.state.emailID)
                formdata.append("role_selected", selRole);

                var token = "";
                if (sessionStorage.getItem("platform") === 'azure') {
                    token = sessionStorage.getItem("id_token");
                } else {
                    token = sessionStorage.getItem("access_token");
                }
                formdata.append("token", token);
                formdata.append("platform", sessionStorage.getItem("platform"));

                this.props.dispatch(updateUserAgreement(formdata));
            } else {
                document.getElementById("roleSelect_Label").innerHTML = "Select atleast one role to continue";
            }

        } else
            
            if (this.state.useralreadyExists) {
                const newEmail = document.getElementById("emailID");
                newEmail.classList.add("border-danger");
                document.getElementById("email_Label").innerHTML = T.translate("error_Codes.UMIDAE");

                console.log("Please Enter Valid Email");
            } else {
                console.log("Please Enter Valid Email");
                if (!this.refs.emailRef.isValid()) {
                    const newEmail = document.getElementById("emailID");
                    newEmail.classList.add("border-danger");
                    document.getElementById("email_Label").innerHTML = "Enter a valid Email";
                    document.getElementById("email_Label").innerHTML = "Email address Eg: mail@mail.com";

                }
            }
    }
    componentWillReceiveProps(nextProps) {
       
      // this.resetForm();
    }
    resetForm(){
        this.setState({
            disableSubmit: true,
            role_selected: "",
            role_selected_hardware: "",
            roles: [],
            selectedRoles: [],
            hardware_sel: "",
            useralreadyExists: false,
            emailID: "",
            selectedList:[],
            loading : false
            
        });
        document.getElementById("agreeCheck").checked =false;
        this.multiselectRef.current.resetSelectedValues();
    }
    enableSubmit(e) {
        if (document.getElementById("agreeCheck").checked) {
            this.setState({ disableSubmit: false })
        } else {
            this.setState({ disableSubmit: true })
        }
    }

    isUndefined = (value) => {
        return (value === undefined);
    }
    handleRadioChange(e) {
        // this.setState({[e.target.name]:[e.target.value]});
        const { name, value } = e.target;
        var hardware = e.target.value;
        var role = this.state.role_selected;
        var role_s = hardware + ":" + role;
        this.setState({ role_selected_hardware: role_s, hardware_sel: hardware });
        document.getElementById("opnunit_Label").innerHTML = " ";
        console.log(role_s);
    }
    emailValidationHandler = () => {
        const newEmail = document.getElementById("emailID");
        
        //const existEmail = false ;
        if (this.state.emailID === " " || this.isEmpty(this.state.emailID) ||
            this.isUndefined(this.state.emailID)) {
            newEmail.classList.add("border-danger");
            document.getElementById("email_Label").innerHTML = "Email Address can't be empty";
        }
        else if (!this.validateEmail(this.state.emailID)) {
            newEmail.classList.add("border-danger");
            document.getElementById("email_Label").innerHTML = "Email address is invalid";
            document.getElementById("email_Label").innerHTML = "Email address Eg: mail@mail.com";
        } else {
            newEmail.classList.remove("border-danger");
            document.getElementById("email_Label").innerHTML = " ";
            return true;
        }
    }
    isEmpty = (value) => {
        return (value === "" || value === null);
    }
    validateEmail(event) {
        var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        return re.test(event);
    }
    userValidationHandler = () => {
        if (this.emailValidationHandler()) {
            return true;
        } else {
            return false;
        }
    }

    onSelect(selectedList, selectedItem) {
        document.getElementById("roleSelect_Label").innerHTML = " ";
        if (selectedItem.id.indexOf("Package_Release_Manager") != -1) {
            this.setState({ displayHardware: true });
        }
        this.setState({ selectedRoles: selectedList });


    }

    onRemove(selectedList, removedItem) {
        if (removedItem.id.indexOf("Package_Release_Manager") != -1) {
            this.setState({ displayHardware: false });
        }
        this.setState({ selectedRoles: selectedList });
    }
    closeMessage() {
        document.getElementById("successmessage").style.display = 'none';
    }
    onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }
    enableTC() {

        this.setState({ enableTCModal: true })
    }
    closeTerms() {
        this.setState({ enableTCModal: false })
    }
    validateUserName(event) {
        const newEmail = document.getElementById("emailID");
        return Axios
            .get(process.env.UAT_SCC + "/itrams/usermanagement/checkUser?emailID=" + this.state.emailID)
            .then((response) => {
                if (response.data) {
                    this.setState({ useralreadyExists: true })
                    const newEmail = document.getElementById("emailID");
                    newEmail.classList.add("border-danger");
                    document.getElementById("email_Label").innerHTML = "USER MAIL ALREADY EXISTS IN THE DATA BASE !! PLEASE CHOOSE DIFFERENT ONE";
                    return "UMIDAE";
                } else {
                    this.setState({ useralreadyExists: false })
                    document.getElementById("email_Label").innerHTML = " ";
                    return true;
                }
            })
            .catch((error) => {
                newEmail.classList.remove("border-danger");
                document.getElementById("email_Label").innerHTML = " ";
                return true;
            })

        return true;
    }

    handleAzureLogin = () =>  {
        msalConfig.auth.redirectUri = process.env.AZURE_REDIRECT_URL;
        const msalInstance = new PublicClientApplication(msalConfig);
        msalInstance.loginPopup(loginRequest)
        .then(body => {
            console.log(body);
            sessionStorage.setItem("email", body.account.idTokenClaims.email);
            sessionStorage.setItem("access_token", body.accessToken);
            //sessionStorage.setItem("ciam_refresh_token", body.refresh_token);
            sessionStorage.setItem("id_token", body.idToken);
            sessionStorage.setItem("isAuthenticated", true);
            sessionStorage.setItem("platform", Constants.AZURE);

            window.location.href = "/packageinfo";
        });
        
    }

    updateEmailLogin = (event) => {
        const element = event.currentTarget;
        const elementId = element.id;
        const elementValue = element.value;
        const updatedState = {
            ...this.state
        }
        updatedState[elementId] = elementValue;
        this.setState(updatedState);
    }

    redirectToLoginPage = () => {
        const valid = this.validateEmailLogin();
        if(!valid) {
            this.setState({
                validatePackageInformation : valid
            })
        } else {
            this.setCookie("email", this.state.emailLoginRedirect, 7);
            if (this.state.emailLoginRedirect.includes("bosch.com")) {
                this.handleAzureLogin();
            } else {
                this.redirectToCiamLogin();
            }
        }
    }

    validateEmailLogin = () => {
        let errors = {};
        const acceptEmail = ["bosch.com", "kubota.com", "cummins.com"];
        var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if(this.state.emailLoginRedirect.length === 0) {
            return false;        
        }

        const isMatch = acceptEmail.some(element => this.state.emailLoginRedirect.includes(element));

        if (!emailRegex.test(this.state.emailLoginRedirect)) {
            errors["emailLoginRedirect"] = "Email input is invalid.";
            this.setState({errors: errors});
            return false;
        } else if (!isMatch) {
            errors["emailLoginRedirect"] = "This email is not accepted. Please contact RBEI-PAC-ServiceHelpDesk@in.bosch.com.";
            this.setState({errors: errors});
            return false;
        } else {
            errors["emailLoginRedirect"] = null;
            this.setState({errors: errors});
            return true;
        }
    }

    onKeyUp = () => {
        this.validateEmailLogin();
    }

    setCookie(name, value, daysToExpire) {
        const date = new Date();
        date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + "; " + expires;
    }

    getCookie(name) {
        const cookieString = document.cookie;
        const cookies = cookieString.split(';');

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return null;
    }

render() {
    const { username, password, invalidUsername, invalidPassword, displayHardware } = this.state;
    const { data, loading } = this.state;
    let apiLoading = null;
    if (this.props.loading) {
        apiLoading = (
            <BackDrop show={true} message="Registering !!!" /> //{this.state.message}
        )
    }

        return (

            <div class="outer">

                {/*<img style={{ width: '10%' }} src={"./images/logo_black.png"} />*/}
                <div class="inner_left_top">
                    <h3 style={{ textAlign: 'center', fontWeight: 'bold' }}> {process.env.customer} DM SelfUpdate</h3>
                    <h6 style={{ textAlign: 'center' }}> {process.env.loginmessage} </h6>
                    {/* <p style= {{fontSize:15,fontWeight:'bold'}} > DM FOTA Cummins v6.4.1  </p>
                    <img class="FOTAImage" src={"./images/Updates_Over-the-Air.jpg"} />*/}
                </div>
                {  /* <div class="inner_right">
                    <h3 style={{ textAlign: 'center', fontWeight: 'bold' }}>DM FOTA Cummins</h3>
                    <h6 style={{ textAlign: 'center' }}>Login or Register to avail DMFOTA Services</h6>
                    <div id="registered" >
                        <br></br>
                        <p style={{ fontSize: 13, fontWeight: 'bold' }} >Already Registered ? </p>
                        <button class="loginButton_ciam" href="#" onClick={this.redirectToCiamLogin}>Login with Bosch Account    </button>
                        
                        <p style={{ fontSize: 10 }}>Already Registered with us? If so click the above button to login to avail our DMFOTA services </p>
                    </div>
                    <div style={{ fontSize: 14 }}>
                        <p style={{ fontSize: 13, fontWeight: 'bold' }} >New to DMFOTA ? </p>
                        <button class="loginButton_ciam" href="#" onClick={this.showRegistration} >Click here to Register</button>
                    </div>
                    <p style={{ fontSize: 10 }}>If you have never registered before you will need to create an account. If you have registered in the past ,sign in on the top </p>
                </div>*/}

                {/* <div class="inner_left_bottom">

                    <button class="loginButton_bosch" href="#" onClick={this.redirectToCiamLogin}>
                        Sign in with Singlekey ID</button>
                    <button class="loginButton_bosch" href="#" onClick={this.handleAzureLogin}>
                        Sign in with Bosch Account</button> */}

                    {/*  <button class="loginButton_bosch" href="#" onClick={this.showRegistration} >Register New User</button>>*/}

            {/* </div> */}
                <div>
               

                    {this.state.displayLogin ?
                        <Modal show={this.state.displayLogin}>
                            <Modal.Header onClick={this.handleClose} closeButton >
                                <h4 style={{  color: '#26547a',textAlign: 'center', fontWeight: 'bold' }}>Register</h4>
                                {/*<a className="rounded border d-flex text-danger" title="Close"><i id="closebutton" className="material-icons">close</i>
                                </a>*/}
                            </Modal.Header>
                            <Modal.Body>
                                <div class="package-info-content">
                                    {this.props.displaySuccessMessage ?
                                        <div id="successmessage" style={{ backgroundColor: '#26547a', border: "#000 solid", borderRadius: '0.3em' }}>
                                            <a style={{ paddingLeft: '95%', display: "inline-block" }}><i id="closebutton" onClick={this.closeMessage} className="rounded border d-flex text-danger material-icons">close</i></a>
                                            <span class="text-success_new">Your Request has been registered. Please contact {process.env.customer} Operations Team ({process.env.Opsemail}) for further assistance.</span>
                                        </div> : null}
                                    {this.props.displayErrorMessage ?
                                        <span class="text-danger">Error Processing Request. Please try after sometime</span>
                                        : null}

                                    <table  style={{  color: '#26547a'}}>
                                        <tr>
                                            <td>
                                                <div class="form-row">

                                                    <Input mandatory="true"
                                                        type="email"
                                                        name="emailID"
                                                        id="emailID"
                                                        text="Email Address"
                                                        ref="emailRef"
                                                        reqcapitals="NRA"
                                                        reqnumbers="NRA"
                                                        reqsplchars="NRA"
                                                        placeholder="Email"
                                                        class="form-control_new"
                                                        validator="true"
                                                        minchars="6"
                                                        maxchars="200"
                                                        size="33%"
                                                        style={{ width: '65%' }}
                                                        onChange={(e) => this.handleChange(e)}
                                                        value={this.state.emailID}
                                                        onKeyUp={this.emailValidationHandler}
                                                       // instacheck={this.validateUserName.bind(this)}
                                                        hint="Email" />
                                                    <label id="email_Label" class="fieldError userManagementError" ></label>

                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <label class="control-label" ref="selected_roles">Roles
                                            <span class="text-danger">*</span></label>
                                            <div class="form-row">
                                                <Multiselect
                                                    class="multiselectClass"
                                                    size="80"
                                                    options={this.state.options} // Options to display in the dropdown
                                                    selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                                                    onSelect={this.onSelect} // Function will trigger on select event
                                                    onRemove={this.onRemove} // Function will trigger on remove event
                                                    displayValue="name" // Property name to display in the dropdown options
                                                    placeholder="Select Role"
                                                  //  showCheckbox="true"
                                                    avoidHighlightFirstOption="true"
                                                    ref={this.multiselectRef}
                                                />
                                                <label id="roleSelect_Label" class="fieldError userManagementError" ></label>
                                            </div>
                                        </tr>
                                        {this.state.displayHardware ?
                                            <tr>
                                                <br></br>
                                                <div class="form-row">

                                                    <label class="control-label" ref="selected_roles">Operational Unit
                                                <span class="text-danger">* </span> <span>&nbsp;</span></label>

                                                    <div>
                                                        <input type="radio" value="PSBU" name="hardware" onChange={this.handleRadioChange} />
                                                        <span style={{ fontWeight: '500', fontSize: "14px", paddingTop: "2%" }} class="control-label"><span>&nbsp;</span> PSBU</span><span>&nbsp;</span>

                                                        <input type="radio" value="EBU" name="hardware" onChange={this.handleRadioChange} />
                                                        <span style={{ fontWeight: '500', fontSize: "14px" }} class="control-label"><span>&nbsp;</span> EBU</span><span>&nbsp;</span>

                                                        <input type="radio" value="Bosch" name="hardware" onChange={this.handleRadioChange} />
                                                        <span style={{ fontWeight: '500', fontSize: "14px" }} class="control-label"><span>&nbsp;</span> Bosch</span><span>&nbsp;</span>
                                                    </div>
                                                    <label id="opnunit_Label" class="fieldError userManagementError" ></label>
                                                </div>
                                            </tr> : null}
                                        <tr>
                                            {/* <br></br>*/}
                                            <input type="checkbox" id="agreeCheck" onChange={this.enableSubmit} name="userAgreecheckbox" />
                                            <span>&nbsp;</span> <span style={{ color: '#26547a', fontSize: '14px' }} class="text-style">I understand and agree to  </span> <span>&nbsp;</span>
                                            {/*<a class="text-style" style={{ color: '#26547a', textDecorationLine: 'underline' }} href="/resources/Terms_and_Conditions.pdf#toolbar=0" target="_blank">Data Privacy Notice</a>*/}
                                        <a class="text-style" style={{ color: '#26547a', fontSize: '14px' ,textDecorationLine: 'underline' }} href="/terms" target="_blank">Data Privacy Notice</a>
                                            {/*<embed height="200px" contextmenu="return false" src="/resources/Terms_and_Conditions.pdf#toolbar=0" frameborder="0" width="100%" />*/}
                                        </tr>
                                    </table>
                                    
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <div class="footer_elements">
                                    <button style={{ marginRight: '10px' }} id="submitButton" disabled={this.state.disableSubmit} onClick={this.handleSubmit}> Submit</button>
                                    <button style={{ marginLeft: '10px' }} onClick={this.handleClose} >Cancel</button>
                                  
                                </div>
                            </Modal.Footer>
                            <div>{apiLoading}</div> 
                        </Modal>
                         
                        : null}
                         
                </div>
               

               {this.getCookie("email") == null ? <Modal show={true}>
                    <Modal.Header style={{ justifyContent: 'center', padding: '10px 0 0 0' }}>
                        <h3 style={{ color: "#26547a", textAlign: 'center', fontWeight: 'bold' }}>Please input email</h3>
                        <Modal.Title class="text-dark"> </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ paddingBottom: '0' }}>
                        <div class="form-group">
                            <label style={{ textTransform: 'capitalize' }}>
                                User email
                                <span class = "text-danger"> *</span>
                            </label>
                            <input
                                id="emailLoginRedirect"
                                type="email"
                                ref="emailLoginRedirect"
                                class = {
                                    !this.state.validateEmailLoginRedirect 
                                    && 
                                    this.state.emailLoginRedirect.length == 0 ?
                                    "form-control border-danger" : 
                                    "form-control"
                                }
                                value = {this.state.emailLoginRedirect}
                                onKeyUp = {this.onKeyUp}
                                onChange = {this.updateEmailLogin}
                                autoFocus={true}
                            />
                            <div class="invalid">{this.state.errors["emailLoginRedirect"]}</div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ paddingBottom: '0' }}>
                        <div style={{ float: 'right', width: '20%' }}>
                            <button style={{ margin: '0 0 15px 0', fontSize: '16px' }} id="loginBtn" class="loginButton" onClick={this.redirectToLoginPage}>Login</button>
                        </div>
                    </Modal.Footer>
                </Modal> : null}

            </div>
        );
    }
}
